export const AUTHENTICATED_EMPLOYEE_JWT = "authenticatedEmployee";
export const WEBSOCKET_URL = "ws://localhost:9000";
export const WEBSOCKET_CONNECTED_KEY = "websocketConnected";
export const LOCALSTORAGE_SHIPMENTS_KEY = "shipmentsTab";
export const LOCALSTORAGE_ORDERS_SHIPMENTS_KEY = "ACTIVE_ORDERS_TABLE_TAB_KEY";
